export default "__VITE_ASSET__DngwFtA3__"